import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { map } from 'rxjs/operators';

@Component({
  selector: 'select2',
  templateUrl: './select2.component.html',
  styles: []
})
export class Select2Component implements OnChanges, OnInit {
  ctrl: FormControl;
  listFiltered: Observable<any[]>;
  @Input() level = '0'; // Filter Level 0: without dependency; 1: 1, 2: 2
  @Input() optionValue: string; // Object property print in option
  @Input() optionText: string; // Object property print in option
  @Input() primaryKey: string; // primaryKey Name
  @Input() primaryKeyValue: any; // primaryKey default value
  @Input() firstFilterName: string; // First Filter
  @Input() firstFilterValue: any; // First Filter
  @Input() secondFilterName: string; // Second Filter
  @Input() secondFilterValue: any; // second Filter
  @Input() placeholder: string; // Placeholder
  @Input() required = false; // If the Field is requied
  @Input() readonly: boolean; // If the Field is requied
  @Input() list: any[];
  @Output() data: EventEmitter<any> = new EventEmitter();

  constructor() {
    this.ctrl = new FormControl();
    if (this.list === undefined) {
      this.list = null;
    }
  }

  ngOnInit() {
    this.initFilter(this.list);
    this.ctrl.setValue(this.primaryKeyValue);
    if (this.readonly === true) {
      this.ctrl.disable();
    }
  }

  initFilter(list) {
    this.listFiltered = this.ctrl.valueChanges
      .pipe(
        startWith(''),
        map(obj => obj ? this.filterList(obj) : this.filter(list))
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    const list: SimpleChange = changes.list;
    if (list !== undefined && list !== null) {
      this.initFilter(list.currentValue);
      this.setValue();
    }
    const ffv: SimpleChange = changes.firstFilterValue;
    if (ffv !== undefined) {
      this.initFilter(this.list);
      this.ctrl.setValue(null);
    }
    const sfv: SimpleChange = changes.secondFilterValue;
    if (sfv !== undefined) {
      this.initFilter(this.list);
      this.ctrl.setValue(null);
    }
  }

  filterList(name: string) {
    const subList = this.filter(this.list);
    if (subList != null) {
      return subList.filter(obj =>  obj[this.optionValue].toLowerCase().indexOf(name.toLowerCase()) === 0);
    } else {
      return null;
    }
  }

  filter(list: any[]): Array<any> {
    if (list === undefined || list === null) {
      return  null;
    }
    if (this.level === '0') {
      return list;
    } else {
      if (this.level === '1') {
        if (this.firstFilterValue !== undefined && this.firstFilterValue !== null) {
          return list.filter(obj =>  obj[this.firstFilterName].toString() === this.firstFilterValue.toString());
        }
        return null;
      } else {
        if (this.level === '2') {
          if (this.firstFilterValue !== null && this.firstFilterValue !== undefined
            && this.secondFilterValue !== null && this.secondFilterValue !== undefined ) {
            return list.filter(obj =>
              obj[this.firstFilterName].toString() === this.firstFilterValue.toString() &&
              obj[this.secondFilterName].toString() === this.secondFilterValue.toString()
            );
          }
        }
        return null;
      }
    }
  }

  sendId(name: string) {
    const result = this.filterList(name);
    if ( result.length > 0 ) {
      this.data.emit(result[0]);
    } else {
      this.data.emit(null);
    }
  }

  setValue() {
    if (this.level === '0') {
      if (this.primaryKeyValue !== undefined && this.primaryKeyValue !== null) {
        const result = this.list.find(obj => obj[this.primaryKey].toString() === this.primaryKeyValue.toString() );
        if ( result != null) {
          this.ctrl.setValue(result[this.optionValue]);
        } else {
          this.ctrl.setValue(null);
        }
      }
    } else {
      if (this.level === '1') {
        if (this.primaryKeyValue !== undefined && this.primaryKeyValue !== null) {
          const result = this.list.find(obj =>
            obj[this.primaryKey].toString() === this.primaryKeyValue.toString()
            && obj[this.firstFilterName].toString() === this.firstFilterValue.toString()
          );
          if ( result != null) {
            this.ctrl.setValue(result[this.optionValue]);
          } else {
            this.ctrl.setValue(null);
          }
        } else {
          this.ctrl.setValue(null);
        }
      } else {
        if (this.level === '2') {
          if (this.primaryKeyValue !== undefined && this.primaryKeyValue !== null
            && this.secondFilterValue !== undefined && this.secondFilterValue !== null
          ) {
            const result = this.list.find(obj =>
              obj[this.primaryKey].toString() === this.primaryKeyValue.toString()
              && obj[this.firstFilterName].toString() === this.firstFilterValue.toString()
              && obj[this.secondFilterName].toString() === this.secondFilterValue.toString()
            );
            if ( result != null) {
              this.ctrl.setValue(result[this.optionValue]);
            } else {
              this.ctrl.setValue(null);
            }
          } else {
            this.ctrl.setValue(null);
          }
        }
      }
    }
  }
}
